/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Monthly_Metrics_Total_YearInputs */

const es_billing_monthly_metrics_total_year = /** @type {(inputs: Billing_Monthly_Metrics_Total_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total anual`)
};

const en_billing_monthly_metrics_total_year = /** @type {(inputs: Billing_Monthly_Metrics_Total_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly total`)
};

/**
* | output |
* | --- |
* | "Yearly total" |
*
* @param {Billing_Monthly_Metrics_Total_YearInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_monthly_metrics_total_year = /** @type {((inputs?: Billing_Monthly_Metrics_Total_YearInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Monthly_Metrics_Total_YearInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_monthly_metrics_total_year(inputs)
	return en_billing_monthly_metrics_total_year(inputs)
});
export { billing_monthly_metrics_total_year as "billing.monthly.metrics.total_year" }